import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { useSortManager } from '@/src/hooks/srp/sortManager'
import { Box, Button, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

interface SortOptionsSelectorProps {
    onApply?: () => void
}

const SortOptionsSelector = ({ onApply }: SortOptionsSelectorProps) => {
    const { sortOptions, handleSortSelect } = useSortManager()
    const tCommon = useTranslations('common')
    const [selected, setSelected] = useState<string>(
        sortOptions.find(opt => opt.isActive)?.sortKey || sortOptions[0]?.sortKey || ''
    )

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelected(e.target.value)
    }

    const handleApply = () => {
        handleSortSelect(selected)
        onApply?.()
    }
    return (
        <Box px={3} py={2} height="100%" display="flex" flexDirection="column" justifyContent="space-between">
            <RadioGroup value={selected} onChange={handleChange}>
                {sortOptions.map(option => (
                    <ErrorBoundaryWrapper
                        identifier={`sortTab-${option.id}-mobile-srp`}
                        fallback={null}
                        key={option.id}
                    >
                        <FormControlLabel
                            value={option.sortKey}
                            control={<Radio color="primary" />}
                            label={
                                <Box>
                                    <Typography fontWeight={700}>{option.label}</Typography>
                                    <Typography fontSize={14} color="grey.600">
                                        {option.priceAndDuration}
                                    </Typography>
                                </Box>
                            }
                            sx={{ mb: 1.5 }}
                        />
                    </ErrorBoundaryWrapper>
                ))}
            </RadioGroup>

            <Button variant="contained" fullWidth color="primary" onClick={handleApply}>
                {tCommon('apply')}
            </Button>
        </Box>
    )
}

export default SortOptionsSelector
